<template>
  <Layout>
    <UploadProductSectionWidget v-if="!aiAssistSelectingData" />
    <MainSection :ai-assist-selecting-data="aiAssistSelectingData" />
  </Layout>
</template>

<script>
import Layout from "@/components/Partials/Layout";
import UploadProductSectionWidget from "@/components/HomePage/UploadProductSectionWidget";
import MainSection from "./MainSection";
export default {
  components: { Layout, MainSection, UploadProductSectionWidget },
  data() {
    return {
      aiAssistSelectingData: false,
    };
  },
  mounted() {
    if (this.$route.query.aiAssist) {
      this.aiAssistSelectingData = true;
    }
  },
};
</script>

<style scoped></style>
